'use strict';

window.LEGENDAS_APLICACOES = {
  equilibrio: {
    descricao: 'Menos de 7 dias',
    cor: '#4394c2',
    icon: 'icon-pulverization-fill',
    cursor: 'default',
    optionsMap: {
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 0.5,
      fillColor: '#4394c2',
      fillOpacity: 0.8
    }
  },
  controle: {
    descricao: 'Entre 7 e 15 dias',
    cor: '#315e76',
    icon: 'icon-pulverization-fill',
    cursor: 'default',
    optionsMap: {
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 0.5,
      fillColor: '#315e76',
      fillOpacity: 0.8
    }
  },
  alerta: {
    descricao: 'Mais de 15 dias',
    cor: '#333e45',
    icon: 'icon-pulverization-fill',
    cursor: 'default',
    optionsMap: {
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 0.5,
      fillColor: '#333e45',
      fillOpacity: 0.9
    }
  }
};

window.OPERACOES = {
  operacao_pulverizacao: 'Defensivos',
  operacao_correcao_solo: 'Correção de Solo',
  operacao_semeadura: 'Semeadura'
};

window.OPTIONS_MAP_DEFAULT_APLICACOES = {
  strokeColor: '#FFFFFF',
  strokeWeight: 1,
  strokeOpacity: 0.8,
  fillOpacity: 0
};

window.PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO = 5;

// eslint-disable-next-line max-lines-per-function,max-params
angular.module('webAgro1App').factory('AplicacoesService', function($http, $rootScope, filterFilter, RestService,
  UnidadesService, $timeout, DecimalsService) {
  const isDecimalV2Enabled = DecimalsService.isDecimalV2Enabled;
  // eslint-disable-next-line complexity
  const getFilters = function(filters) {
    return !filters ? {} : {
      data_inicial: filters.dataInicial || null,
      data_final: filters.dataFinal || null,
      page: filters.page || null,
      gleba: (filters.gleba || {}).id || null,
      atividade: (filters.cultura || {}).id || null,
      estadio: (filters.estadio || {}).id || null,
      grupo_insumo: (filters.grupoInsumo || {}).id || null,
      operacao: filters.operacao || $rootScope.parametros.operacao_pulverizacao.id,
      epoca: (filters.epoca || {}).codigo,
      safra: (filters.safra || {}).id || null,
      status: filters.status || null
    };
  };

  const getExisteDiferencaDoseRecomendadoAplicado = function(recomendado, aplicado, percentualRecomendadoAplicado) {
    if (!recomendado.id) {
      return true;
    }
    const doseRecomendado = isDecimalV2Enabled() ?
      DecimalsService.truncateDoseOrQuantity(recomendado.dose) :
      +recomendado.dose;
    const doseAplicado = isDecimalV2Enabled() ?
      DecimalsService.truncateDoseOrQuantity(aplicado.qt_dose) :
      +aplicado.qt_dose;

    if (!doseRecomendado) {
      return true;
    }
    // eslint-disable-next-line no-mixed-operators
    return Math.abs(doseAplicado * 100 / doseRecomendado - 100) > percentualRecomendadoAplicado;
  };

  const getProdutoClassificacao = function(application, produto, percentualRecomendadoAplicado) {
    let produtoRecomendacao = filterFilter(application.recommendation.insumos, { id: produto.item_codigo }, true)[0];
    if (!produtoRecomendacao) {
      produtoRecomendacao =
        filterFilter(application.recommendation.insumos, { produto: { item_id: produto.item_codigo } }, true)[0] || {};
      produtoRecomendacao = {
        id: (produtoRecomendacao.produto || {}).item_id,
        dose: produtoRecomendacao.qt_dose
      };
    }
    return {
      produto: !produtoRecomendacao.id,
      dose: getExisteDiferencaDoseRecomendadoAplicado(produtoRecomendacao, produto, percentualRecomendadoAplicado)
    };
  };

  /* eslint-disable complexity,max-len */
  const classificacaoAplicacao = function(application) {
    return {
      area: +application.area !== +(application.recommendation.gleba.area_total || application.recommendation.gleba.area_recomendada),
      dtIni: (application.dt_ini < application.recommendation.data_inicio) ||
             (application.dt_ini > application.recommendation.data_termino),
      dtFim: (application.dt_fim < application.recommendation.data_inicio) ||
             (application.dt_fim > application.recommendation.data_termino),
      temperaturaInicial: (+application.allData.atributo.temperatura_inicial < +(application.recommendation.temperatura || {}).minima) ||
                          (+application.allData.atributo.temperatura_inicial > ((application.recommendation.temperatura || {}).maxima || Number.MAX_SAFE_INTEGER)),
      temperaturaFinal: (+application.allData.atributo.temperatura_final < +(application.recommendation.temperatura || {}).minima) ||
                        (+application.allData.atributo.temperatura_final > ((application.recommendation.temperatura || {}).maxima || Number.MAX_SAFE_INTEGER)),
      umidadeInicial: (+application.allData.atributo.umidade_inicial < +(application.recommendation.umidade || {}).minima) ||
                      (+application.allData.atributo.umidade_inicial > ((application.recommendation.umidade || {}).maxima || Number.MAX_SAFE_INTEGER)),
      umidadeFinal: (+application.allData.atributo.umidade_final < +(application.recommendation.umidade || {}).minima) ||
                    (+application.allData.atributo.umidade_final > ((application.recommendation.umidade || {}).maxima || Number.MAX_SAFE_INTEGER)),
      horasSemChuva: (+application.allData.atributo.horas_sem_chuva < +application.recommendation.horas_sem_chuva),
      velocidadeVento: (+application.allData.atributo.velocidade_maxima_vento < (+(application.recommendation.vento || {}).maxima)),
      vazao: (application.allData.vazao && application.recommendation.vazao && +application.allData.vazao !== +application.recommendation.vazao),
      bico: (application.allData.bico && application.recommendation.bico && application.allData.bico !== application.recommendation.bico)
    };
  };
  /* eslint-enable */

  return {
    listSeedings: function(filters) {
      const url = `${SERVER}v2/seeding`;
      return $http.get(url, { params: filters || {} });
    },

    list: function(filters) {
      const params = getFilters(filters);
      return RestService.getFromUrl(`${SERVER + API_VERSION}aplicacoes/simple`, params);
    },

    listComplete: function(filters) {
      const params = getFilters(filters);
      params.complete = true;
      return RestService.getFromUrl(`${SERVER + API_VERSION}aplicacoes`, params);
    },

    get: function(id) {
      return $http.get(`${SERVER + API_VERSION}aplicacoes/${id}`);
    },

    getStatusPulverizacaoGlebas: function(filters) {
      return $http.get(`${SERVER + API_VERSION}aplicacoes_status_glebas`, { params: getFilters(filters) });
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION}aplicacoes/${id}`);
    },

    update(id, data) {
      return $http.patch(`${SERVER}v1/aplicacoes/${id}`, data);
    },

    trackings: function(id) {
      return $http.get(`${SERVER}v1/aplicacoes/${id}/tracking`);
    },

    vinculaAplicacaoCronograma(data) {
      return $http.patch(`${SERVER + API_VERSION}aplicacoes/vincula_aplicacao_cronograma`, data);
    },

    desvinculaAplicacaoCronograma(data) {
      return $http.patch(`${SERVER + API_VERSION}aplicacoes/desvincula_aplicacao_cronograma`, data);
    },

    finalizaCronogramaFungicidaParameter(data) {
      return $http.patch(`${SERVER + API_VERSION}aplicacoes/finaliza_cronograma_fungicida_parameter`, data);
    },

    setClassificacaoAplicadoRecomendado: function(application, percentualRecomendadoAplicado) {
      if (!application.recommendation) {
        return;
      }
      application.classificacao = classificacaoAplicacao(application);
      application.classificacao.itensAplicacao = application.allData.itens.map(function(produto) {
        return getProdutoClassificacao(application, produto, percentualRecomendadoAplicado);
      });

      const _this = this;

      application.classificacao.insumosRecomendacao = application.recommendation.insumos.map(function(produto) {
        const produtoAplicado = filterFilter(application.allData.itens, { item_codigo: produto.id }, true)[0] || {};
        return {
          produto: !produtoAplicado.item_codigo,
          aplicado: _this.getAppliedPercentage(application.recommendation, produto, produtoAplicado)
        };
      });
    },

    // eslint-disable-next-line max-lines-per-function
    setClassificacaoAplicadoRecomendadoSemeadura(plantio, percentualRecomendadoAplicado) {
      if (!plantio.recommendation) {
        return;
      }
      const _this = this;

      plantio.classificacao = {
        area: +plantio.area !== +(plantio.recommendation.area || plantio.recommendation.gleba.area_total),
        dtIni: plantio.dt_ini < plantio.recommendation.data_inicio ||
               plantio.dt_ini > plantio.recommendation.data_termino,
        dtFim: plantio.dt_fim < plantio.recommendation.data_inicio ||
               plantio.dt_fim > plantio.recommendation.data_termino
      };

      const recommendationProducts = plantio.recommendation.cultivares.concat(plantio.recommendation.adubos);

      plantio.classificacao.itensAplicacao = plantio.allData.itens.map(function(produto) {
        let produtoRecomendacao = filterFilter(recommendationProducts, { insumo_id: produto.item_codigo }, true)[0];
        const sementeDestinoFilter = { item_estoque: { codigo_semente_destino: produto.item_codigo } };
        const sementeDestinoRecomendacao = filterFilter(recommendationProducts, sementeDestinoFilter, true)[0];

        produtoRecomendacao = sementeDestinoRecomendacao || produtoRecomendacao || {};

        return {
          produto: !_.get(produtoRecomendacao, 'insumo_id'),
          dose: getExisteDiferencaDoseRecomendadoAplicado(produtoRecomendacao, produto, percentualRecomendadoAplicado)
        };
      });

      plantio.classificacao.insumosRecomendacao = recommendationProducts.map(function(produto) {
        let produtoAplicacao = filterFilter(plantio.allData.itens, { item_codigo: produto.insumo_id }, true)[0];
        const sementeOrigemFilter = { item_codigo: produto.item_estoque.codigo_semente_destino };

        if (sementeOrigemFilter.item_codigo) {
          const sementeOrigem = filterFilter(plantio.allData.itens, sementeOrigemFilter)[0];
          produtoAplicacao = sementeOrigem || produtoAplicacao || {};
        }

        return {
          produto: !_.get(produtoAplicacao, 'item_codigo'),
          aplicado: _this.getAppliedPercentage(plantio.recommendation, produto, produtoAplicacao)
        };
      });
    },

    normalize: function(product, value) {
      const unidade = UnidadesService.getMeasureUnitysFromDescription((product.unidade || {}).descricao);
      if (unidade.conversao) {
        return value / unidade.conversao;
      }

      return value;
    },

    getDoseNormalized: function(product) {
      const dose = product.dose || product.qt_dose;
      const doseNormalized = this.normalize(product, dose);
      return isDecimalV2Enabled() ? DecimalsService.truncateDoseOrQuantity(doseNormalized) : doseNormalized;
    },

    getRecommendationTotal: function(product, recommendation) {
      const area = (product.area || recommendation.gleba.area_recomendada || recommendation.gleba.area_total);

      return this.getDoseNormalized(product) * area;
    },

    getAppliedTotal: function(product) {
      return this.normalize(product, product.qt_total);
    },

    getDoseAppliedPercentage: function(productRecommendation, productApplied) {
      if (!productApplied || !productRecommendation) {
        return 0;
      }

      const doseRecommendation = this.getDoseNormalized(productRecommendation);
      const doseApplied = this.getDoseNormalized(productApplied);

      if (!doseRecommendation || !doseApplied) {
        return 0;
      }

      return doseApplied / doseRecommendation * 100;
    },

    getAppliedPercentage: function(recommendation, productRecommendation, productApplied) {
      if (!productApplied || !productRecommendation) {
        return 0;
      }

      const recommendationTotal = this.getRecommendationTotal(productRecommendation, recommendation);
      const appliedTotal = this.getAppliedTotal(productApplied);

      if (!recommendationTotal || !appliedTotal) {
        return this.getDoseAppliedPercentage(productRecommendation, recommendation);
      }

      return appliedTotal / recommendationTotal * 100;
    },

    closeOpenRecommendationsModal: function(closeRecommendations) {
      $timeout(function() {
        $('#list-application-history .panel-group').scroll(function() {
          closeRecommendations();
        });
      }, 500);
    }
  };
});
